import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalBoxStyle = {
  background: "#fff",
  borderRadius: 10,
  padding: "16px",
  width: "90vw",
  maxWidth: 800,
  height: "85vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
};

function PdfModal({ title, src, onClose }) {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalBoxStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <strong style={{ fontSize: 16 }}>{title}</strong>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", lineHeight: 1 }}
          >
            ✕
          </button>
        </div>
        <iframe src={`${src}#toolbar=0&navpanes=0`} title={title} style={{ flex: 1, border: "none", borderRadius: 6 }} />
      </div>
    </div>
  );
}

function DiamondBorder() {
  return (
    <svg
      viewBox="0 0 400 240"
      style={{
        position: "absolute",
        width: "100%",
        height: "100%"
      }}
    >
      <defs>
        <linearGradient id="rainbowAuth" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ff0000" />
          <stop offset="20%" stopColor="#ff9900" />
          <stop offset="40%" stopColor="#ffff00" />
          <stop offset="60%" stopColor="#00ff99" />
          <stop offset="80%" stopColor="#0099ff" />
          <stop offset="100%" stopColor="#cc00ff" />
        </linearGradient>
      </defs>

      <polygon
        points="60,20 340,20 380,90 200,220 20,90"
        fill="none"
        stroke="url(#rainbowAuth)"
        strokeWidth="3"
      />
    </svg>
  );
}
          export default function AuthPage() {
      const { login } = useAuth();
      const navigate = useNavigate();

      const [username, setUsername] = useState("");
      const [password, setPassword] = useState("");
      const [showTermsModal, setShowTermsModal] = useState(false);

     
                const handleSubmit = async (e) => {
        e.preventDefault();

          if (!username.trim() || !password.trim()) {
              alert("Please enter a username and password.");
        return;
      }

 
        try {

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/create-user`, {
        method: "POST",
        headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      username: username,
      password: password
    })
  });

       const data = await response.json();

          if (!response.ok) {
         alert(data.error);
          return;
      }

         login({ username: data.username || username, account_id: data.alpacaAccountId });

    localStorage.setItem("spectraToken", data.token);

    navigate("/Dashboard");

     alert("Account Created Successfully");

      } catch (error) {

       console.error(error);
             alert("Server connection error");

      console.log("Submitting onboarding:", form);
     }
   };
   


    const pageWrapper = {
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f2f7ff"
};

    const titleStyle = {
         fontSize: 20,
         fontWeight: 600,
         marginBottom: 4
};

     const subtitleStyle = {
         marginBottom: 14,
         color: "#666",
         textAlign: "center",
         maxWidth: 480,
         fontSize: 13
};
 
     const diamondContainer = {
         position: "relative",
         width: 780,
         height: 560
};

     const formPosition = {
         position: "absolute",
         bottom: 195,
         left: "50%",
         transform: "translateX(-50%)",
         width: 220
};

     const inputStyle = {
          width: "100%",
          padding: "12px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          boxSizing: "border-box"
};

     const primaryButton = {
          margin: "14px auto 0 auto",
          display: "block",
          padding: "12px",
          borderRadius: "6px",
          background: "#00bfff",
          border: "none",
          color: "#fff",
          fontWeight: 600,
          width: "60%",
          cursor: "pointer"
};

      const secondaryButton = {
           margin: "12px auto 0 auto",
           display: "block",
           padding: "12px",
           borderRadius: "6px",
           background: "#ffc400",
           border: "none",
           color: "#fff",
           fontWeight: 600,
           width: "60%",
           cursor: "pointer"
};

return (
    <div style={pageWrapper}>
    {showTermsModal && (
      <PdfModal
        title="SMA Agreement & Terms"
        src="/SMAAgreementAndTerms.pdf"
        onClose={() => setShowTermsModal(false)}
      />
    )}

    <h2 style={titleStyle}>Create Account</h2>
    <p style={subtitleStyle}>
      Create a new username and password to continue onboarding, for Spectra trading account verification.
    </p>

    <button
      type="button"
      onClick={() => setShowTermsModal(true)}
      style={{
        position: "relative",
        top: 14,
        marginBottom: 14,
        padding: "7px 18px",
        borderRadius: 6,
        border: "1px solid #00bfff",
        background: "transparent",
        color: "#00bfff",
        fontWeight: 600,
        cursor: "pointer",
        fontSize: 13,
      }}
    >
      View SMA Agreement &amp; Terms
    </button>

    <div style={diamondContainer}>
      <DiamondBorder />

    <form onSubmit={handleSubmit} style={formPosition}>
        <div style={{ marginTop: 12 }}>
          <input
           type="text"
           placeholder="Username"
           value={username}
           onChange={(e) => setUsername(e.target.value)}
           style={inputStyle}
          />
        </div>

        <div style={{ marginTop: 12 }}>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={inputStyle}
          />
        </div>

        <button type="submit" style={primaryButton}>
          Create Account
        </button>

        <button
          type="button"
          onClick={() => navigate("/SignIn")}
          style={secondaryButton}
        >
          Sign In
        </button>
      </form>
    </div>
  </div>
);
}